import { Component, Input } from '@angular/core'
import { ConveyanceTypeRead, OrderPatch, OrderRead, OrdersService } from '@app/generated'
import { SelectComponent } from '@core/components/select/select.component'
import { NotificationService } from '@core/services/notification.service'
import { OptionComponent } from '@core/components/option/option.component'
import { FormFieldComponent } from '@core/components/form-field/form-field.component'
import { ButtonComponent } from '@core/components/button/button.component'
import { FormControl, FormGroup } from '@angular/forms'
import { ConfirmationComponent } from '@core/components/confirmation/confirmation.component'
import { ModalService } from '@core/services/modal.service'
import { finalize } from 'rxjs'
import { LoaderService } from '@core/services/loader.service'
import { getItemTranslation } from '@app/general/utils/get-item-translation'
import { CommonModule } from '@angular/common'

@Component({
	standalone: true,
	selector: 'order-change-conveyance-type-form',
	templateUrl: './change-conveyance-type.form.html',
	styleUrls: ['./change-conveyance-type.form.scss'],
	imports: [SelectComponent, OptionComponent, FormFieldComponent, ButtonComponent, ConfirmationComponent, CommonModule],
})
export class ChangeConveyanceTypeComponent {
	@Input() order: OrderRead = {} as OrderRead
	conveyanceTypes: ConveyanceTypeRead[] = []
	orderPath: OrderPatch = {} as OrderPatch
	conveyanceTypeForm = {
		formGroup: new FormGroup({
			conveyanceType: new FormControl<ConveyanceTypeRead | null>(null),
		}),
	}
	protected readonly getItemTranslation = getItemTranslation
	protected readonly confirmButtonText = $localize`Confirm`
	protected readonly cancelButtonText = $localize`Cancel`

	constructor(
		private ordersService: OrdersService,
		private notificationService: NotificationService,
		private modalService: ModalService,
		private loaderService: LoaderService,
	) {}

	ngOnInit() {
		this.fetchConveyanceTypes()
		this.conveyanceTypeForm.formGroup.patchValue({
			conveyanceType: this.order.conveyance_type,
		})
	}

	fetchConveyanceTypes() {
		this.ordersService.getConveyanceTypes().subscribe({
			next: (response: ConveyanceTypeRead[]) => {
				this.conveyanceTypes = response
			},
			error: error => {
				let message = $localize`Was not able to fetch conveyance types`
				if (error.code === 422) {
					message = $localize`Form contains errors`
				}
				this.notificationService.error(message)
			},
		})
	}

	updateConveyanceType() {
		this.orderPath = {
			conveyance_type_id: this.conveyanceTypeForm.formGroup.controls['conveyanceType'].value?.id,
		}
		this.patchData(this.order)
	}

	cancelUpdateConveyanceType() {
		this.modalService.modalRef.close(false)
	}

	private patchData(order: OrderRead) {
		if (order.id) {
			this.ordersService
				.patchOrder(order.id, this.orderPath)
				.pipe(finalize(() => this.loaderService.disable()))
				.subscribe({
					next: () => {
						const newValue = this.conveyanceTypes.find(
							elem => elem.id === this.conveyanceTypeForm.formGroup.controls['conveyanceType'].value?.id,
						)
						this.modalService.modalRef.close(newValue)
						this.notificationService.success($localize`Order conveyance type has been updated`)
					},
					error: () => {
						this.notificationService.error($localize`Failed to patch order conveyance type`)
					},
				})
		}
	}
}
